import { clamp } from './math.ts';

/**
 * How far a shoved hull is through its drift, given the mover's arc-length
 * progress. Zero until the mover reaches the impact, then 0–1 over whatever
 * of the mover's path is left. The click already resolved the physics; this
 * only decides when the picture starts.
 *
 * Picture timing, not the sweep. The collision module can be deleted and the
 * scene still compiles; with no hits, `hitAt` is never set and this stays idle.
 */
export function driftProgress(moverProgress: number, hitAt: number): number {
  const hit = clamp(hitAt, 0, 1);
  const progress = clamp(moverProgress, 0, 1);

  if (progress <= hit || hit >= 1) {
    return progress >= 1 && hit >= 1 ? 1 : 0;
  }

  return (progress - hit) / (1 - hit);
}
